module.exports = __webpack_public_path__ + "static/abonoAcompanhamento-f5248604bdda9bf231da299e875f7e68.gif";